import { z } from 'zod';

export const zFeatureType = z.enum([
  'PARKING_FACILITY',
  'PARK_AND_RIDE_FACILITY',
  'PICKUP_PARKING_FACILITY',
  'STATION',
]);

export const FeatureType = zFeatureType.enum;

export type FeatureType = z.infer<typeof zFeatureType>;
